<template>
  <v-container>
    <v-layout v-if="error" row>
      <v-flex xs12 sm6 offset-sm3>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignup">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="email" label="Email" id="email" v-model="email" type="email" required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="password" label="Password" id="password" v-model="password" type="password" required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="confirmPassword" label=" Confirm Password" id="confirmPassword" v-model="confirmPassword" type="password"
                      :rules="[comparePasswords]">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-btn type="submit" :disabled="!loading" :loading="!loading">
                      Registrieren
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                      </v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'

  export default {
    name: 'SignUpUser',
    data () {
      return {
        email: '',
        password: '',
        confirmPassword: ''
      }
    },
    computed: {
      ...mapGetters({
        error: 'error',
        loading: 'isLoading',
        loggedIn : 'loggedIn'
      }),
      comparePasswords () {
        return this.password !== this.confirmPassword ? 'Passwörte stimmen nicht überein' : ''
      }
    },
    watch : {
      loggedIn(value) {
        if (value === true) {
          this.$router.push('/profile')
        }
      }
    },
    methods: {
      onSignup () {
        this.$store.dispatch('signUpUser', {
          email: this.email,
          password: this.password
        })
      },
      onDismissed () {
        this.$store.dispatch('clearError')
        console.log('dismissed alert')
      }
    },
    created () {
      this.$store.dispatch('resetLoading')
      this.$store.dispatch('resetUser')
    }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/user/Signup.vue